/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "azure-devops-ui/Card", "azure-devops-ui/Header", "azure-devops-ui/Page", "azure-devops-ui/Spinner", "azure-devops-ui/Status", "azure-devops-ui/Utilities/Date", "history", "react", "simple-query-string", "../../Resources", "../Common/KubeCardWithTable", "../Common/KubeZeroData", "../Common/PageTopHeader", "../Common/Tags", "../Constants", "../FluxCommon/ActionsCreatorManager", "../FluxCommon/StoreManager", "../KubeFactory", "../Pods/PodsActionsCreator", "../Pods/PodsTable", "../RunDetails", "../Selection/SelectionActionCreator", "../Utils", "./ServicesActionsCreator", "./ServicesStore", "./ServiceUtils", "./ServiceDetails.scss"], function (require, exports, Card_1, Header_1, Page_1, Spinner_1, Status_1, Date_Utils, history_1, React, queryString, Resources, KubeCardWithTable_1, KubeZeroData_1, PageTopHeader_1, Tags_1, Constants_1, ActionsCreatorManager_1, StoreManager_1, KubeFactory_1, PodsActionsCreator_1, PodsTable_1, RunDetails_1, SelectionActionCreator_1, Utils_1, ServicesActionsCreator_1, ServicesStore_1, ServiceUtils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var LoadBalancerText = "LoadBalancer";
    var ServiceDetails = /** @class */ (function (_super) {
        __extends(ServiceDetails, _super);
        function ServiceDetails(props) {
            var _this = _super.call(this, props, {}) || this;
            _this._markTTI = function () {
                if (!_this._isTTIMarked) {
                    KubeFactory_1.getTelemetryService().scenarioEnd(Constants_1.Scenarios.ServiceDetails);
                }
                _this._isTTIMarked = true;
            };
            _this._onPodsFetched = function () {
                var servicesStoreState = _this._servicesStore.getState();
                _this.setState({
                    pods: servicesStoreState.podsList || [],
                    arePodsLoading: servicesStoreState.arePodsLoading
                });
            };
            _this._onSelectedPodInvoked = function (event, pod) {
                var selectionActionCreator = ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(SelectionActionCreator_1.SelectionActionsCreator);
                var service = _this.state.service.service;
                selectionActionCreator.selectItem({
                    item: pod,
                    itemUID: pod.metadata.uid,
                    selectedItemType: "pod-details" /* PodDetailsKey */,
                    showSelectedItem: true,
                    properties: {
                        parentUid: service.metadata.uid,
                        serviceSelector: Utils_1.Utils.generateEqualsConditionLabelSelector((service.spec && service.spec.selector) || {}),
                        serviceName: service.metadata.name,
                    }
                });
            };
            _this._setCopiedRowIndex = function (copiedRowIndex) {
                _this.setState({
                    copyTooltipText: copiedRowIndex === 0 ? Resources.CopiedExternalIp : Resources.CopyExternalIp
                });
            };
            _this._isTTIMarked = false;
            _this.state = {
                service: props.service,
                pods: [],
                arePodsLoading: true,
                copyTooltipText: Resources.CopyExternalIp
            };
            KubeFactory_1.getTelemetryService().scenarioStart(Constants_1.Scenarios.ServiceDetails);
            var notifyViewChanged = function (service) {
                if (service.metadata && props.notifyViewChanged) {
                    var metadata = service.metadata;
                    props.notifyViewChanged([{ id: "service-item" /* ServiceItemKey */ + metadata.uid, displayName: metadata.name, url: window.location.href }]);
                }
            };
            if (props.service && props.service.service) {
                notifyViewChanged(props.service.service);
            }
            _this._podsActionsCreator = ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(PodsActionsCreator_1.PodsActionsCreator);
            _this._servicesStore = StoreManager_1.StoreManager.GetStore(ServicesStore_1.ServicesStore);
            var fetchServiceDetails = function (svc) {
                // service currently only supports equals with "and" operator. The generator generates that condition.
                var labelSelector = Utils_1.Utils.generateEqualsConditionLabelSelector(svc && svc.spec && svc.spec.selector || {});
                _this._podsActionsCreator.getPods(KubeFactory_1.KubeFactory.getKubeService(), labelSelector, true);
            };
            if (!props.service) {
                ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(ServicesActionsCreator_1.ServicesActionsCreator).getServices(KubeFactory_1.KubeFactory.getKubeService());
                var getServicesHandler_1 = function () {
                    _this._servicesStore.removeListener(Constants_1.ServicesEvents.ServicesFetchedEvent, getServicesHandler_1);
                    var history = history_1.createBrowserHistory();
                    var queryParams = queryString.parse(history.location.search);
                    var servicesList = _this._servicesStore.getState().serviceList;
                    var services = (servicesList && servicesList.items) || [];
                    var selectedService = services.find(function (s) { return s.metadata.uid === queryParams.uid; });
                    if (selectedService) {
                        notifyViewChanged(selectedService);
                        fetchServiceDetails(selectedService);
                        _this.setState({
                            service: ServiceUtils_1.getServiceItems([selectedService])[0]
                        });
                    }
                };
                _this._servicesStore.addListener(Constants_1.ServicesEvents.ServicesFetchedEvent, getServicesHandler_1);
            }
            else if (props.service.service) {
                fetchServiceDetails(props.service.service);
            }
            _this._servicesStore.addListener(Constants_1.ServicesEvents.ServicePodsFetchedEvent, _this._onPodsFetched);
            return _this;
        }
        ServiceDetails.prototype.render = function () {
            return (React.createElement(Page_1.Page, { className: "service-details-page flex flex-grow" },
                this._getMainHeading(),
                React.createElement("div", { className: "service-details-page-content page-content page-content-top" },
                    this._getServiceDetails(),
                    this._getAssociatedPods())));
        };
        ServiceDetails.prototype.componentWillUnmount = function () {
            this._servicesStore.removeListener(Constants_1.ServicesEvents.ServicePodsFetchedEvent, this._onPodsFetched);
        };
        ServiceDetails.prototype._getMainHeading = function () {
            var item = this.state.service;
            if (item) {
                var statusProps = item.type === LoadBalancerText && !item.externalIP ? Status_1.Statuses.Running : Status_1.Statuses.Success;
                return React.createElement(PageTopHeader_1.PageTopHeader, { className: "s-details-header", title: item.package, statusProps: statusProps });
            }
            return null;
        };
        ServiceDetails.prototype._getServiceDetails = function () {
            var item = this.state.service;
            if (item && item.service) {
                var agoTime = Date_Utils.ago(new Date(item.creationTimestamp), 0 /* Compact */);
                return (React.createElement(Card_1.CustomCard, { className: "service-details-card k8s-card-padding flex-grow bolt-card-no-vertical-padding" },
                    React.createElement(Header_1.CustomHeader, null,
                        React.createElement(Header_1.HeaderTitleArea, null,
                            React.createElement(Header_1.HeaderTitleRow, null,
                                React.createElement(Header_1.HeaderTitle, { className: "text-ellipsis", titleSize: 0 /* Medium */ }, Resources.ServiceDetails)),
                            React.createElement(Header_1.HeaderDescription, { className: "text-ellipsis" }, RunDetails_1.getRunDetailsText(item.service.metadata.annotations, undefined, agoTime)))),
                    React.createElement(Card_1.CardContent, { className: "service-full-details-table" }, this._getServiceDetailsCardContent(item))));
            }
            return null;
        };
        ServiceDetails.prototype._getServiceDetailsCardContent = function (item) {
            var _this = this;
            var serviceDetails = [];
            serviceDetails.push({ key: Resources.TypeText, value: item.type });
            serviceDetails.push({ key: Resources.ClusterIPText, value: item.clusterIP || "-" });
            serviceDetails.push({ key: Resources.ExternalIPText, value: item.externalIP });
            serviceDetails.push({ key: Resources.PortText, value: item.port });
            serviceDetails.push({ key: Resources.SessionAffinityText, value: item.service && item.service.spec && item.service.spec.sessionAffinity || "" });
            serviceDetails.push({ key: Resources.SelectorText, value: item.service ? item.service.spec.selector : {} });
            serviceDetails.push({ key: Resources.LabelsText, value: item.service ? item.service.metadata.labels : {} });
            return (React.createElement("div", { className: "flex-row service-card-content" }, serviceDetails.map(function (data, index) { return _this._renderServiceCellContent(data, index); })));
        };
        ServiceDetails.prototype._renderServiceCellContent = function (data, index) {
            var key = data.key, value = data.value;
            var className = "flex-column body-m " + (index > 0 ? "service-column-padding" : "");
            var getColumnKey = function (keyText, keyClassName) {
                var computedCLassName = "secondary-text service-column-key-padding " + (keyClassName || "");
                return React.createElement("div", { className: computedCLassName }, keyText);
            };
            switch (key) {
                case Resources.TypeText:
                case Resources.ClusterIPText:
                case Resources.PortText:
                case Resources.SessionAffinityText:
                    className = className + " service-basic-column-size";
                    return (React.createElement("div", { className: className, key: index },
                        getColumnKey(key),
                        KubeCardWithTable_1.defaultColumnRenderer(value)));
                case Resources.ExternalIPText:
                    return (React.createElement("div", { className: "body-m service-column-padding", key: index },
                        getColumnKey(key, "service-extip-column-size"),
                        KubeCardWithTable_1.renderExternalIpWithCopy(value, this.state.copyTooltipText, this._setCopiedRowIndex)));
                case Resources.LabelsText:
                case Resources.SelectorText:
                    return (React.createElement("div", { className: "flex-grow flex-column service-column-padding", key: index },
                        getColumnKey(key, "body-m"),
                        React.createElement(Tags_1.Tags, { className: "overflow-fade service-tags-column-size", items: value })));
                default:
                    return undefined;
            }
        };
        ServiceDetails.prototype._getAssociatedPods = function () {
            if (this.state.arePodsLoading) {
                return React.createElement(Spinner_1.Spinner, { className: "flex flex-grow loading-pods", size: "large" /* large */, label: Resources.LoadingPodsSpinnerLabel });
            }
            if (!this.state.pods || this.state.pods.length === 0) {
                setTimeout(this._markTTI, 0);
                return KubeZeroData_1.KubeZeroData.getServiceAssociatedPodsZeroData();
            }
            return (React.createElement(PodsTable_1.PodsTable, { contentClassName: "service-pods-table", podsToRender: this.state.pods, headingText: Resources.AssociatedPodsText, onItemActivated: this._onSelectedPodInvoked, showWorkloadColumn: true, markTTICallback: this._markTTI }));
        };
        return ServiceDetails;
    }(React.Component));
    exports.ServiceDetails = ServiceDetails;
});
